<footer class="footer">
    <a href="https://github.com/William-Nogueira/VoeFacil-Frontend" target="_blank">Copyright © {{ getCurrentYear() }}
        VoeFacil.
        Todos os
        direitos reservados.</a>
</footer>